/* src/app/expenses/presenters/expense-detail-city-state-zip/expense-detail-city-state-zip-presenter/expense-detail-city-state-zip.component.scss */
fieldset {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 10rem;
}
::ng-deep .p-dialog .p-dialog-content {
  overflow: visible;
}
::ng-deep .p-dialog .p-dialog-content .p-dropdown {
  width: 100%;
}
/*# sourceMappingURL=expense-detail-city-state-zip.component.css.map */
